// VIP 12 - Page 5: After Admission
// 5-1. PCAS Data
// 5-2. Laboratory Data (at ED arrival)
// 5-3. Discharge Outcome

import React, { useState } from "react";

const Page5 = ({ formData, handleChange, handleCheckboxChange, dtDisplay }) => {
  // 조건부 필드 표시 상태
  const [showTtmTemp, setShowTtmTemp] = useState(false);
  const [showTtmCause, setShowTtmCause] = useState(false);

  // 라디오 버튼 전용 핸들러
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      handleChange({ target: { name, value: "" } });
    } else {
      handleChange({ target: { name, value } });
    }

    // 조건부 필드 표시 로직
    handleConditionalFields(name, value);
  };

  // 조건부 필드 표시 처리
  const handleConditionalFields = (name, value) => {
    switch (name) {
      case "ttm":
        setShowTtmTemp(value === "yes");
        setShowTtmCause(value === "no");
        break;
    }
  };

  // 재사용 가능한 라디오 필드 렌더링 함수
  const renderRadioField = (
    fieldName,
    label,
    options,
    isRequired = false,
    columnType = "2col"
  ) => {
    const wrapperClass =
      columnType === "1col" ? "input-wrapper-1column" : "input-wrapper-2column";
    const blockClass =
      columnType === "1col" ? "block-1column" : "block-2column";
    const titleClass =
      columnType === "1col" ? "item_title_1col" : "item_title_2col";
    const inputClass = columnType === "1col" ? "input_1col" : "input_2col";

    return (
      <div className={wrapperClass}>
        <div className={blockClass}>
          <label className={titleClass}>
            {label}
            {isRequired && <span className="required-mark"> *</span>}
          </label>
          <div className={inputClass}>
            <div className="rad-group">
              {options.map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name={fieldName}
                    value={option.value}
                    checked={formData[fieldName] === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 텍스트 입력 필드 렌더링 함수
  const renderTextField = (
    fieldName,
    label,
    placeholder = "",
    unit = "",
    isRequired = false,
    type = "text"
  ) => {
    return (
      <div className="block-2column">
        <label className="item_title_2col">
          {label}
          {isRequired && <span className="required-mark"> *</span>}
        </label>
        <div className="input_2col">
          <input
            type={type}
            name={fieldName}
            placeholder={placeholder}
            value={formData[fieldName] || ""}
            onChange={handleChange}
          />
          {unit && <span className="unit-text">{unit}</span>}
        </div>
      </div>
    );
  };

  return (
    <section className="vip-form-section">
      <h2 className="section-subtitle">After Admission</h2>

      {/* 5-1. PCAS Data */}
      <fieldset className="basic-info-fieldset">
        <legend>5-1. PCAS Data</legend>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">TTM</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ttm"
                      value={option.value}
                      checked={formData.ttm === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          {showTtmTemp && (
            <div className="block-2column">
              <label className="item_title_2col">TTM temperature</label>
              <div className="input_2col">
                <div className="rad-group">
                  {[
                    { label: "hypothermia", value: "hypothermia" },
                    { label: "normothermia", value: "normothermia" },
                  ].map((option) => (
                    <label key={option.value} className="rad-label">
                      <input
                        type="radio"
                        className="rad-input"
                        name="ttm_temp"
                        value={option.value}
                        checked={formData.ttm_temp === option.value}
                        onClick={handleRadioClick}
                        onChange={() => {}}
                      />
                      <div className="rad-design"></div>
                      <div className="rad-text">{option.label}</div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {showTtmCause && (
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "15px",
              borderRadius: "5px",
              margin: "10px 0",
            }}
          >
            {renderRadioField(
              "ttm_cause",
              "Cause of not doing TTM",
              [
                { label: "obey command", value: "obey command" },
                { label: "refusal", value: "refusal" },
                { label: "hopeless", value: "hopeless" },
                { label: "others", value: "others" },
              ],
              false,
              "1col"
            )}
          </div>
        )}

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">CAG</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="cag"
                      value={option.value}
                      checked={formData.cag === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <div className="input_2col"></div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">PCI</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="pci"
                      value={option.value}
                      checked={formData.pci === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">CABG</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="cabg"
                      value={option.value}
                      checked={formData.cabg === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">IABP</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="iabp"
                      value={option.value}
                      checked={formData.iabp === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">CRRT</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="crrt"
                      value={option.value}
                      checked={formData.crrt === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">TCP</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="tcp"
                      value={option.value}
                      checked={formData.tcp === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <div className="input_2col"></div>
          </div>
        </div>
      </fieldset>

      {/* 5-2. Laboratory Data (at ED arrival) */}
      <fieldset className="basic-info-fieldset">
        <legend>5-2. Laboratory Data (at ED arrival)</legend>

        <div className="input-wrapper-2column">
          {renderTextField("wbc", "WBC")}
          {renderTextField("hb", "Hb")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("plt", "Plt")}
          {renderTextField("na", "Na")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("k", "K")}
          {renderTextField("cl", "Cl")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("tco2", "TCO2")}
          {renderTextField("bun", "BUN")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("cr", "Cr")}
          {renderTextField("tbil", "Total_bilirubin")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("ast", "AST")}
          {renderTextField("alt", "ALT")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("ica", "iCa")}
          {renderTextField("phos", "Phosphorous")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("alb", "Albumin")}
          {renderTextField("alp", "ALP")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("pt", "PT (INR)")}
          {renderTextField("aptt", "aPTT")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("crp", "CRP")}
          {renderTextField("ck", "CK")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("ckmb", "CK-MB")}
          {renderTextField("troponin_i", "troponin_i")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("probnp", "proBNP")}
          {renderTextField("ddimer", "D-dimer")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("nse", "NSE")}
          {renderTextField("ph", "pH")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("po2", "pO2")}
          {renderTextField("pco2", "pCO2")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("hco3", "HCO3")}
          {renderTextField("lactate", "Lactate")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("sao2", "SaO2")}
          {renderTextField("scvo2", "ScvO2")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("cortisol", "Cortisol")}
          {renderTextField("acth", "ACTH")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("adh", "ADH")}
          <div className="block-2column">
            <div className="input_2col"></div>
          </div>
        </div>
      </fieldset>

      {/* 5-3. Discharge Outcome */}
      <fieldset className="basic-info-fieldset">
        <legend>5-3. Discharge Outcome</legend>

        <div className="input-wrapper-2column">
          {renderTextField(
            "discharge_date",
            "Discharge Date",
            "",
            "",
            false,
            "datetime-local"
          )}
          <div className="block-2column">
            <label className="item_title_2col">Discharge Type</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "survival discharge", value: "survival discharge" },
                  { label: "death", value: "death" },
                  { label: "transfer", value: "transfer" },
                  { label: "hopeless transfer", value: "hopeless transfer" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="discharge_type"
                      value={option.value}
                      checked={formData.discharge_type === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {renderRadioField(
          "cpc_discharge",
          "CPC at discharge",
          [
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}

        {renderRadioField(
          "mrs_discharge",
          "mRS at discharge",
          [
            { label: "0", value: "0" },
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "6", value: "6" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}

        {renderRadioField(
          "cpc_1month",
          "CPC at 1 month",
          [
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}

        {renderRadioField(
          "mrs_1month",
          "mRS at 1 month",
          [
            { label: "0", value: "0" },
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "6", value: "6" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}

        {renderRadioField(
          "cpc_3month",
          "CPC at 3 months",
          [
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}

        {renderRadioField(
          "mrs_3month",
          "mRS at 3 months",
          [
            { label: "0", value: "0" },
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "6", value: "6" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}

        {renderRadioField(
          "cpc_6month",
          "CPC at 6 months",
          [
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}

        {renderRadioField(
          "mrs_6month",
          "mRS at 6 months",
          [
            { label: "0", value: "0" },
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "6", value: "6" },
            { label: "pending", value: "pending" },
          ],
          false,
          "1col"
        )}
      </fieldset>
    </section>
  );
};

export default Page5;
